import { Button, Typography } from "@mui/material";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import React from "react";

type FilterOptionProps = {
    onClick: () => void;
    title: string;
};
const FilterOption = ({ onClick, title }: FilterOptionProps) => {
    return (
        <Button
            onClick={onClick}
            variant="contained"
            fullWidth
            sx={{
                height: 55,
                backgroundColor: "#4F8CAD",
                borderRadius: 2,
                paddingX: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                textTransform: "none",
                "&:hover": { backgroundColor: "#417B99" },
            }}
        >
            <Typography sx={{ color: "#fff" }}>{title}</Typography>
            <ChevronLeftIcon sx={{ color: "#F1EEDB", fontSize: 25 }} />
        </Button>
    );
};

export default FilterOption;
